import { createContext, FC } from 'react';

export type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: { [key: string]: string | number | undefined } | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    isSmallerSbCategoryTilesVariant?: boolean | null;
    isSbTopNavVariant?: boolean | null;
    isPdpMetaDescRemovalVariant?: boolean | null;
    pdpImageSeoTestGroup?: boolean | null;
    locale?: string | null;
    isMobilePdpRedesign?: boolean | null;
    isPdpSidebarRemovePaidShippingVariant?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    locale: null,
    isSearchQueryApplied: null,
    isSmallerSbCategoryTilesVariant: null,
    isSbTopNavVariant: null,
    isPdpMetaDescRemovalVariant: null,
    pdpImageSeoTestGroup: null,
    isMobilePdpRedesign: null,
    isPdpSidebarRemovePaidShippingVariant: null,
});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isSearchQueryApplied,
    isSmallerSbCategoryTilesVariant,
    isSbTopNavVariant,
    isPdpMetaDescRemovalVariant,
    pdpImageSeoTestGroup,
    locale,
    isMobilePdpRedesign,
    isPdpSidebarRemovePaidShippingVariant,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isSearchQueryApplied,
                isSmallerSbCategoryTilesVariant,
                isSbTopNavVariant,
                isPdpMetaDescRemovalVariant,
                pdpImageSeoTestGroup,
                locale,
                isMobilePdpRedesign,
                isPdpSidebarRemovePaidShippingVariant,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
